import { client } from './generated/client.gen';

export interface ApiClientOptions {
  /**
   * API 베이스 URL. 비우면 same-origin(`/`)으로 호출한다.
   * - 개발: Vite dev 프록시가 `/v1`을 api 서버로 넘긴다 → 빈 값
   * - Cloudflare Pages 배포: API가 별도 오리진이다 → `https://api.labflow.kr`
   */
  baseUrl?: string;
  /** 모든 요청에 붙일 기본 헤더 */
  headers?: Record<string, string>;
}

/** 앱 부팅 시 1회 호출한다. */
export function configureApiClient(options: ApiClientOptions = {}): void {
  client.setConfig({
    baseUrl: options.baseUrl && options.baseUrl.length > 0 ? options.baseUrl : '/',
    // 세션 쿠키 기반 인증을 전제로 한다 (L2-06 §4).
    credentials: 'include',
    headers: options.headers,
  });
}
